<template>
    <div class="fs5-table-clients">
        <div class="get-paid-filters">
            <div class="get-paid-search">
                <img class="get-paid-img" src="/internacional/public/office5/img/franchise_dashboard/svg/search.svg">
                <input class="get-paid-input" v-model="f_filter_by" type="text"
                       :placeholder="decodeString(view.translations['label_nome'])
                       + ', '
                       + 'E-mail, '
                       + decodeString(view.translations['label-invoice'])
                       + ', '
                       + decodeString(view.translations['plan-value'])">
            </div>
            <div class="get-paid-select">
                <select class="select-filter" v-model="f_status" id="f_status">
                    <option value="">{{ view.translations['status'] }}</option>
                    <option value="a_receber">{{ view.translations['label_aguardando_liberacao'] }}</option>
                    <option value="disponivel">{{ view.translations['office2_ganhos_disponivel'] }}</option>
                    <option value="reembolsado">{{ view.translations['label_devolvido'] }}</option>
                    <option value="pago">{{ view.translations['office2_ganhos_pago'] }}</option>
                </select>
            </div>
            <div class="get-paid-select">
                <select class="select-filter" v-model="f_type" id="f_type">
                    <option value="">{{ view.translations['office2_ganhos_tipo'] }}</option>
                    <option value="direct-sale">{{ view.translations['commission-label-direct-sale'] }}</option>
                    <option value="level-1">{{ view.translations['commission-label-level'].replace("%s", "1") }}</option>
                    <option value="ambassador">{{ view.translations['commission-label-ambassador'] }}</option>
                    <option value="venda_direta_concessao">{{ view.translations['commission-label-venda-direta-concessao'] }}</option>
                    <option value="saldo_concessao">{{ view.translations['commission-label-saldo_concessao'] }}</option>
                    <option value="network">{{ view.translations['commission-label-network'] }}</option>
                </select>
            </div>
            <div class="get-paid-select">
                <select class="select-filter" v-model="f_tipo_fatura" id="f_tipo_fatura">
                    <option value="">{{ view.translations['franquia_faturas_tipo'] }}</option>
                    <option value="normal">{{ view.translations['standard'] }}</option>
                    <option value="franquia">{{ view.translations['title_office_franquia'] }}</option>
                </select>
            </div>
            <div v-if="view.plansFilter.length > 1" class="get-paid-select">
                <select class="select-filter" v-model="f_plans" id="f_plans">
                    <option v-for="(plan,i) in view.plansFilter" :key="i" :value="plan['value']">{{ plan['title'] }}</option>
                </select>
            </div>
            <div v-if="view.dateFilter.length > 1" class="get-paid-select">
                <select class="select-filter" v-model="f_date" id="f_date">
                    <option v-for="(date,i) in view.dateFilter" :key="i" :value="date['value']">{{ date['title'] }}</option>
                </select>
            </div>
            <div class="get-paid-submit">
                <fs5-button
                    :label="view.translations['label_filtrar']"
                    :btn-type="'primary'"
                    :text-transform-type="'uppercase'"
                    id="get-paid-btn-submit"
                    @clicked="checkStorage()"
                ></fs5-button>
            </div>
        </div>
        <div v-if="showTable == false" class="get-paid-spinner">
            <spring-spinner :animation-duration="2000" :size="50" color="#0080fc"/>
        </div>
        <div v-if="showTable && totalItems == 0" class="get-paid-message">
            <p>{{ view.translations['label_no_register_search'] }}</p>
        </div>
        <div v-if="showTable && totalItems > 0" class="get-paid-table">
            <table class="get-paid-table-items">
                <thead class="get-paid-table-thead">
                    <th>{{ view.translations['office2_ganhos_cliente'] }}</th>
                    <th class="get-paid-dispensable">{{ view.translations['office2_ganhos_tipo'] }}</th>
                    <th class="get-paid-dispensable">{{ view.translations['office2_ganhos_data'] }}</th>
                    <th class="get-paid-dispensable">{{ view.translations['plan-value'] }}</th>
                    <th>{{ view.translations['commission-value'] }}</th>
                    <th class="get-paid-dispensable-second">Status</th>
                </thead>
                <tbody class="get-paid-table-body">
                    <tr v-for="(item,i) in typeData == 0 ? dataTable[this.currentPage-1]['data']['paginated_earnings'] : dataTable['data']['paginated_earnings']" :key="i">
                        <td :title="item['data']['client']['email']">
                            <b class="get-paid-table-name">{{ item['data']['client']['name'].length > 18 ? item['data']['client']['name'].slice(0,18) + '...' : item['data']['client']['name'] }}</b> <br>
                            {{ item['data']['client']['id'] }}{{ shouldShowEmail(item['data']['client']['email'], item['data']['label_values']['type']['title']) }} <br>
                            {{ _isEmpty(item['data']['client']['first_payment']) ? '' : view.translations.first_payment + ' ' + item['data']['client']['first_payment'] }}
                        </td>
                        <td class="get-paid-dispensable"><div :style="'backgroundColor:'+item['data']['label_values']['type']['color']" class="get-paid-table-type" v-html="item['data']['label_values']['title']"></div></td>
                        <td class="get-paid-dispensable">{{ item['data']['date_html'] }}</td>
                        <td class="get-paid-dispensable">{{ item['data']['is_saldo_concessao_lifestyle'] ?  ' - ' :  item['currency'] + ' ' + item['valor_pago'] }}</td>
                        <td>
                            {{ item['currency'] + ' ' + item['valor'] }} <br>
                            <p v-html="item['meio_pagamento']" class="get-paid-table-meio-pagamento"></p>
                            <p v-if="item['currency_from'] && item['currency_from'] != item['currency']" v-html="view.translations['conversion_from'] + ' ' + item['currency_from']" class="get-paid-table-meio-pagamento"></p>
                        </td>
                        <td :style="'color:'+item['data']['status']['color']" class="get-paid-table-status">
                            <div class="get-paid-status-line">
                                <div class="get-paid-status-circle" :style="'backgroundColor:'+item['data']['status']['background']">
                                    <img class="get-paid-status-icon" :src="'/internacional/public/office5/img/franchise_dashboard/svg/'+item['data']['status']['icon']" :alt="item['data']['status']['title']">
                                </div>
                                <div class="get-paid-status-text" :style="'color:'+item['data']['status']['color']">
                                    {{ item['data']['status']['title'] }}
                                    <p v-if="!item['data']['status']['date'] == false" v-html="item['data']['status']['date']" class="get-paid-table-status-date"></p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="showTable && totalItems > 0" class="get-paid-pagination">
            <div v-if="currentPage != 1 ? true : false">
                <button class="get-paid-btn-pagination" :title="view.translations['button_voltar']" @click="backPage()"><</button>
            </div>
            <div v-html="currentPage + ' ' + view.translations['fs5_get_paid_of'] + ' ' + totalPage"></div>
            <div v-if="currentPage == totalPage ? false : true">
                <button class="get-paid-btn-pagination" :title="view.translations['label_next']" @click="nextPage()">></button>
            </div>
        </div>
    </div>
</template>

<script>
    import { SpringSpinner } from 'epic-spinners'
    export default {
        name: 'fs5-table-clients',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        data() {
            return {
                currentPage: 0,
                totalPage: 0,
                totalItems: 0,
                showTable: false,
                dataTable: [],
                typeData: 0,
                typeUrl: "com",
                f_filter_by: "",
                f_type: "",
                f_status: "",
                f_plans: "",
                f_tipo_fatura: "",
                f_date: ""
            }
        },
        methods: {
            decodeString(val) {
              return new DOMParser().parseFromString(val, 'text/html').querySelector('body').textContent;
            },
            shouldShowEmail(email, type) {
              return type == 'direct-sale'
                ? (email.length > 15 ? ' - ' + email.slice(0,15) + '...' : ' - ' + email)
                : ''
            },
            _isEmpty(val){
              return isEmpty(val)
            },
            nextPage()
            {
                this.currentPage++;
                this.checkStorage();
            },
            backPage()
            {
                this.currentPage--;
                this.checkStorage();
            },
            checkStorage() {
                this.showTable = false;
                if(!this.f_filter_by && !this.f_status && !this.f_type && !this.f_tipo_fatura && !this.f_plans && !this.f_date)
                {
                    // Não tem filtro
                    this.typeData = 0;
                    if(!this.dataTable[this.currentPage-1])
                    {
                        this.requestTable();
                    }
                    else
                    {
                        this.totalItems  = this.dataTable[this.currentPage-1]['data']['total_items'];
                        this.currentPage = this.dataTable[this.currentPage-1]['data']['current_page'];
                        this.totalPage   = this.dataTable[this.currentPage-1]['data']['total_pages'];
                        this.showTable   = true;
                    }
                }
                else
                {
                    // Tem filtro
                    this.typeData = 1;
                    this.filterRegister();
                }
            },
            filterRegister()
            {
                axios
                    .get('/' + this.view.lang +
                    '/office/franchise-system/paginated-earnings?data-type=json' +
                    '&f_filterby='+this.f_filter_by+
                    '&f_status='+this.f_status+
                    '&f_type='+this.f_type+
                    '&f_tipo_fatura='+this.f_tipo_fatura+
                    '&f_plan='+this.f_plans+
                    '&f_purchased_date='+this.f_date+
                    '&page='+this.currentPage
                    )
                    .then((response) => {
                        this.currentPage = response.data['current_page'];
                        this.dataTable   = {page: this.currentPage, data: response.data};
                        this.totalItems  = response.data['total_items'];
                        this.totalPage   = response.data['total_pages'];
                        this.showTable   = true;
                    })
                    .catch(e => {});
            },
            requestTable()
            {
              axios
                .get('/' + this.view.lang + '/office/franchise-system/paginated-earnings?data-type=json&page='+this.currentPage)
                .then((response) => {
                    this.currentPage                   = response.data['current_page'];
                    this.dataTable[this.currentPage-1] = {page: this.currentPage, data: response.data};
                    this.totalItems                    = response.data['total_items'];
                    this.totalPage                     = response.data['total_pages'];
                    this.showTable                     = true;
                })
                .catch(e => {});
            }
        },
        mounted() {
            this.requestTable();
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    .fs5-table-clients {
        font-family: $fs5-font2;
    }
    .get-paid-pagination,
    .get-paid-filters,
    .get-paid-status-line{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .get-paid-status-line{
        align-items: center;
        column-gap: 4%;
    }
    .get-paid-filters{
        align-items: center;
        background-color: $fs5-color2;
        padding: 1em;
        justify-content: space-between;
        border-radius: 8px;
        gap: 1rem;
    }
    .get-paid-search {
        background-color: $fs5-color17;
        padding: 0.6em;
        border-radius: 8px;
        display: flex;
        height: 2.5em;
    }
    .get-paid-table-thead {
        font-size: 0.9em;
    }
    .get-paid-status-circle {
        height: 2.5em;
        width: 2.5em;
        border-radius: 50%;
    }
    .get-paid-status-icon {
        transform: translate(0.51em, 0.51em);
        width: 1.5em;
    }
    .get-paid-table-thead,
    .get-paid-pagination{
        background-color: $fs5-color17;
    }
    .get-paid-table-body {
        background-color: $fs5-color2;
        color: $fs5-color19;
        text-transform: none;
        text-align: center;
        font-size: 0.9em;
        td{
            padding: 0.7em;
            border-bottom: 1px solid $fs5-color-20;
        }
        td:first-child,
        .get-paid-table-meio-pagamento,
        .get-paid-table-status-date{
            font-weight: 400;
        }
        td:first-child,
        .get-paid-table-status{
            text-align: left;
        }
    }
    .get-paid-table-type {
        padding: 0.2em;
        border-radius: 1em;
        color: $fs5-color2;
        font-weight: 400;
    }
    .get-paid-table-name {
       letter-spacing: 0.1em;
    }
    .get-paid-table-items {
        width: 100%;
        th{
            padding: 1em;
            text-align: center;
            font-size: 1em;
        }
    }
    .get-paid-spinner,
    .get-paid-message {
        display: flex;
        justify-content: center;
        text-align: center;
        padding: 1em;
    }
    .get-paid-input {
        background-color: transparent;
        border: none;
        outline: none;
        color: $fs5-color11;
        width: 16em;
        font-size: 0.85em;
    }
    .get-paid-input::placeholder {
        color: $fs5-color11;
    }
    .get-paid-img {
        font: inherit;
        height: 1.4em;
        width: auto;
        margin-right: 1em;
    }
    .get-paid-select {
        background-color: $fs5-color2;
        border: 1px solid $fs5-color18;
        border-radius: 4px;
        padding: 0.6em;
        height: 2.5em;
    }
    .select-filter {
        color: $fs5-color9;
        border: none;
        outline: none;
        font-size: 0.85em;
        width: 10em;
    }
    .get-paid-pagination {
        justify-content: center;
        padding: 1em;
        column-gap: 1em;
        text-transform: lowercase;
    }
    .get-paid-btn-pagination {
        background-color: transparent;
        outline: none;
        border: none;
        cursor: pointer;
        color: $fs5-color19;
    }
    #get-paid-btn-submit {
        height: 2em;
    }
    @media only screen and (max-width: 1353px) {
        .get-paid-status-circle {
            display: none;
        }
    }
    @media only screen and (max-width: 920px) {
        .get-paid-dispensable {
            display: none;
        }
        .get-paid-submit,
        .get-paid-select,
        .get-paid-search,
        .select-filter {
            width: 100%;
        }
    }
    @media only screen and (max-width: 320px) {
        .get-paid-table-status,
        .get-paid-dispensable-second {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/get_paid/user/table_clients/index.vue